import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import MyOfficeAssignmentSummarySearchParams from './MyOfficeAssignmentSummarySearchParams';
import AssignmentService from '../../../../Services/AssignmentService';
import MyOfficeAssignmentSummaryItem from '../../../../Domain/MyOfficeAssignmentSummaryItem';

export default class OrphanedAssignmentsClientGroupedAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new MyOfficeAssignmentSummarySearchParams(),
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={MyOfficeAssignmentSummaryItem}
          serviceFunction={AssignmentService.GetMyOfficeAssignmentSummaryBySearching}
          convertDBItemsFunction={AssignmentService.ConvertMyOfficeAssignmentSummaryDBItems}
          searchItem={this.state.searchItem}
          orderBy='CompletedDate'
          orderDirection='DESC'
          errorCode='MOASA29'
        />
      </div>
    );
  }
}
